import { Box } from "@mui/material";

import SynthesisBudget from "@/modules/play/Components/Synthesis/SynthesisBudget";
import SynthesisCarbon from "@/modules/play/Components/Synthesis/SynthesisCarbon";
import SynthesisConsumption from "@/modules/play/Components/Synthesis/SynthesisConsumption";
import SynthesisProduction from "@/modules/play/Components/Synthesis/SynthesisProduction";
import { ITeam } from "@/utils/types";

export default SynthesisRecapForPlayer;

function SynthesisRecapForPlayer({ team }: { team: ITeam | null }) {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <SynthesisConsumption />
      <SynthesisProduction team={team} />
      <SynthesisBudget team={team} />
      <SynthesisCarbon team={team} />
    </Box>
  );
}
